var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1452 2.30597L4.80554 5.96632C4.91316 6.07394 5.08728 6.07394 5.19446 5.96632L8.8548 2.30597C9.06173 2.09905 9.39727 2.09905 9.60463 2.30597L9.84481 2.54615C10.0517 2.75307 10.0517 3.08861 9.84481 3.29598L5.38257 7.75821C5.17127 7.96951 4.82873 7.96951 4.61743 7.75821L0.155195 3.29598C-0.0517307 3.08905 -0.0517307 2.75351 0.155195 2.54615L0.395367 2.30597C0.602293 2.09905 0.937835 2.09905 1.1452 2.30597Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/ArrowDownIcon.355d91d9ec636e72e7f8f00fde99173a.svg";
export { ForwardRef as ReactComponent };